import dvaModelExtend from 'dva-model-extend';

import { bindServices } from '@/services/api';
import { createCrudModel } from '@/utils/core/dva';

import { ENTITY_NAME, FETCH_ROUTE, MODEL_NAME } from './constants';

const api = bindServices(MODEL_NAME);
const _model = createCrudModel({
  namespace: MODEL_NAME,
  fetchRoute: FETCH_ROUTE,
  fetchParams: 'PowerBIServerConfiguration',
  entityName: ENTITY_NAME,
  api,
  features: { import: false, bulkActions: true },
});

export default dvaModelExtend(_model, { namespace: MODEL_NAME });
